import React from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import { Label, TextSmall } from '../TextPrimitives'
import { ReplaceDash, toRGBA } from '../../utils'

// TODO: (2) Show gradient if overflowing 

const Wrapper = styled.div`
  overflow: hidden;
`

const UnstyledList = styled.ul`
  list-style: none;
  max-height: 33rem;
  overflow-y: auto;
`

const List = styled(UnstyledList)`
  display: flex;
  flex-direction: column;
  width: calc(100% + 20px);
`

const ItemLabel = styled(Label)`
  width: 8rem;
  flex: 0 0 auto;
  /* align-self: flex-start; */
`

const ValueBox = styled.div`
  word-spacing: ${props => (props.isTimeSpan ? -0.2 : 0)}rem;
  & ul {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
`

const StyledListItem = styled.div`
  display: flex;
  align-items: center;
  margin-right: 17px;
`

const ListItemWrapper = styled.li`
  padding: 1rem 0;
  border-bottom: solid 1px
    ${({ theme }) => toRGBA(theme.colors.greys.light, 0.2)};
  pointer-events: none;
`

const Values = ({ children }) => {
  if (!children) return '-'
  return _.isArray(children) ? (
    <UnstyledList>
      {children.map((children, i) => (
        <TextSmall key={i} as="li">
          {children}
        </TextSmall>
      ))}
    </UnstyledList>
  ) : (
    <TextSmall>{children}</TextSmall>
  )
}

export const ListItem = ({ label, text, isTimeSpan }) => (
  <ListItemWrapper>
    <StyledListItem>
      <ItemLabel>
        <ReplaceDash>{label}</ReplaceDash>
      </ItemLabel>
      <ValueBox isTimeSpan={isTimeSpan}>
        <Values>{text}</Values>
      </ValueBox>
    </StyledListItem>
  </ListItemWrapper>
)

export default ({ data = [], children }) => (
  <Wrapper>
    <List data-scrollable>
      {children ||
        data.map(({ date, text }, i) => (
          <ListItem key={`listItem-${i}`} label={date} text={text} />
        ))}
    </List>
  </Wrapper>
)
